module.exports = __webpack_public_path__ + "img/cnu-attend-01.16851c5e.png";